import { IAuditTableDictionaryApi } from '@/types/dictionary';

/** `bet_order` → `Bet Order` */
function formatAuditTableLabel(name: string): string {
    return name
        .split('_')
        .filter(Boolean)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
}

export class AuditTableDictionaryItem {
    code: string;
    id: number;
    name: string;

    constructor(data: IAuditTableDictionaryApi) {
        this.id = Number(data.id);
        this.code = String(data.name ?? '');
        this.name = formatAuditTableLabel(this.code);
    }
}
